var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-container"},[(!_vm.user_project && _vm.user_company)?_c('ProjectManager',{attrs:{"companyUID":_vm.user_company}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }